"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("@jordibosch20/software_tools_package/dist/index");
var _material = require("@mui/material");
var _Input = _interopRequireDefault(require("@mui/material/Input"));
var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _react = require("react");
var _convertToBase = require("../utils/convertToBase");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function BaseConverter(props) {
  var _useState = (0, _react.useState)(10),
    _useState2 = _slicedToArray(_useState, 2),
    selectInputNumber = _useState2[0],
    setSelectInputNumber = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectBase2 = _useState4[0],
    setSelectBase2 = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectBase8 = _useState6[0],
    setSelectBase8 = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectBase16 = _useState8[0],
    setSelectBase16 = _useState8[1];
  var _useState9 = (0, _react.useState)(10),
    _useState10 = _slicedToArray(_useState9, 2),
    selectBaseCustom = _useState10[0],
    setSelectBaseCustom = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectBaseCustomResult = _useState12[0],
    setSelectBaseCustomResult = _useState12[1];
  var handleSelectInputNumberChange = function handleSelectInputNumberChange(event) {
    setSelectInputNumber(event.target.value);
  };
  function convertDifferentBaseToDecimal(inputBase, base) {
    setSelectInputNumber(parseInt(inputBase, base));
  }
  var handleselectBase2 = function handleselectBase2(event) {
    setSelectBase2(event.target.value);
    convertDifferentBaseToDecimal(event.target.value, 2);
  };
  var handleselectBase8 = function handleselectBase8(event) {
    setSelectBase8(event.target.value);
    convertDifferentBaseToDecimal(event.target.value, 8);
  };
  var handleselectBase16 = function handleselectBase16(event) {
    setSelectBase16(event.target.value);
    convertDifferentBaseToDecimal(event.target.value, 16);
  };
  var handleChange = function handleChange(event) {
    setSelectBaseCustom(event.target.value);
  };
  (0, _react.useEffect)(function () {
    var inputNumber = Number(selectInputNumber);
    setSelectBase2((0, _convertToBase.convertToBase)(inputNumber, 2));
    setSelectBase8((0, _convertToBase.convertToBase)(inputNumber, 8));
    setSelectBase16((0, _convertToBase.convertToBase)(inputNumber, 16));
    setSelectBaseCustomResult((0, _convertToBase.convertToBase)(inputNumber, selectBaseCustom));
  }, [selectInputNumber, selectBaseCustom]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.OneSideCommonComponent, {
      title: props.title,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, {
          variant: "standard",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InputLabel["default"], {
            id: "label-1",
            variant: "contained",
            htmlFor: "input-number",
            shrink: true,
            children: ["Convert number to another base:", " "]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input["default"], {
            labelId: "label-1",
            id: "input-number",
            label: "Sort order",
            className: "select",
            value: selectInputNumber,
            onChange: handleSelectInputNumberChange,
            sx: {
              width: 200,
              // Smaller width
              fontSize: "0.875rem" // Smaller font size
            }
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.InputWithSelectors, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, {
            variant: "standard",
            sx: {
              display: "flex",
              "flex-direction": "row"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel["default"], {
              id: "label-2",
              variant: "contained",
              htmlFor: "base-2",
              shrink: true,
              children: "Base 2 (Binary):"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input["default"], {
              labelId: "label-2",
              id: "base-2",
              label: "Sort order",
              className: "select",
              value: selectBase2,
              onChange: handleselectBase2,
              sx: {
                width: 220,
                // Smaller width
                fontSize: "0.875rem" // Smaller font size
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ToggleCopyButton, {
              textToCopy: selectBase2,
              firstValue: "📋",
              secondValue: "✅"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, {
            sx: {
              display: "flex",
              "flex-direction": "row"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel["default"], {
              variant: "contained",
              htmlFor: "base-8",
              shrink: true,
              children: "Base 8 (Octal):"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input["default"], {
              id: "base-8",
              label: "Sort order",
              className: "select",
              value: selectBase8,
              onChange: handleselectBase8,
              sx: {
                width: 220,
                // Smaller width
                fontSize: "0.875rem" // Smaller font size
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ToggleCopyButton, {
              textToCopy: selectBase8,
              firstValue: "📋",
              secondValue: "✅"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, {
            sx: {
              display: "flex",
              "flex-direction": "row"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel["default"], {
              variant: "contained",
              htmlFor: "base-16",
              shrink: true,
              children: "Base 16 (Hexadecimal):"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input["default"], {
              id: "base-16",
              label: "Sort order",
              className: "select",
              value: selectBase16,
              onChange: handleselectBase16,
              sx: {
                width: 220,
                // Smaller width
                fontSize: "0.875rem" // Smaller font size
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ToggleCopyButton, {
              textToCopy: selectBase16,
              firstValue: "📋",
              secondValue: "✅"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, {
            variant: "standard",
            sx: {
              display: "flex",
              "flex-direction": "row"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InputLabel["default"], {
              id: "label-3",
              variant: "contained",
              htmlFor: "custom-base",
              shrink: true,
              children: ["Custom Base:", " "]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Select["default"], {
              labelId: "label-3",
              id: "custom-base",
              onChange: handleChange,
              value: selectBaseCustom,
              sx: {
                width: 90,
                // Smaller width
                fontSize: "0.875rem",
                // Smaller font size
                ".MuiSelect-select": {
                  // Targeting the internal select element
                  paddingTop: "3px",
                  paddingBottom: "3px",
                  fontSize: "12px"
                }
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 2,
                children: "2"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 3,
                children: "3"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 4,
                children: "4"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 5,
                children: "5"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 6,
                children: "6"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 7,
                children: "7"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 8,
                children: "8"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 9,
                children: "9"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 10,
                children: "10"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 11,
                children: "11"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 12,
                children: "12"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 13,
                children: "13"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 14,
                children: "14"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 15,
                children: "15"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 16,
                children: "16"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 17,
                children: "17"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 18,
                children: "18"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 19,
                children: "19"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 20,
                children: "20"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 21,
                children: "21"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 22,
                children: "22"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 23,
                children: "23"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 24,
                children: "24"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 25,
                children: "25"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 26,
                children: "26"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 27,
                children: "27"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 28,
                children: "28"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 29,
                children: "29"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 30,
                children: "30"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 31,
                children: "31"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 32,
                children: "32"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 33,
                children: "33"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 34,
                children: "34"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 35,
                children: "35"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
                value: 36,
                children: "36"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input["default"], {
              label: "Sort order",
              className: "select",
              value: selectBaseCustomResult,
              sx: {
                width: 130,
                // Smaller width
                fontSize: "0.875rem" // Smaller font size
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ToggleCopyButton, {
              textToCopy: selectBaseCustomResult,
              firstValue: "📋",
              secondValue: "✅"
            })]
          })]
        })
      })]
    })
  });
}
var _default = exports["default"] = BaseConverter;